// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.listing-scroll[data-v-4d8929c4] {\n    /* height: 690px; */\n    overflow-y: scroll;\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
